import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { INotificationsServiceConfig } from './interfaces';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private config!: INotificationsServiceConfig;

  constructor(private matSnackSvc: MatSnackBar) {
  }

  init(config: INotificationsServiceConfig): void {
    this.config = config;
  }

  showInfo(message: string): void {
    this.show(message, this.config.infoClasses);
  }

  showSuccess(message: string): void {
    this.show(message, this.config.successClasses);
  }

  showWarn(message: string): void {
    this.show(message, this.config.warnClasses);
  }

  showError(message: string): void {
    this.show(message, this.config.errorClasses);
  }

  private show(message: string, panelClass?: string): void {
    this.matSnackSvc.open(message, undefined, { panelClass: panelClass, duration: this.config.duration });
  }
}
